import { styled } from '../../Styles/stitches.config'
import { StyledLabel } from '../../Atoms/Label/styles'
import { StyledInput } from '../../Atoms/Input/styles'
import { StyledTextarea } from '../../Atoms/Textarea/styles'

export const HelperText = styled('div', {
    alignItems: 'center',
    color: '$neutral500',
    fontSize: '0.875rem',
    display: 'flex',
    gap: '$1',

    variants: {
        helperPlacement: {
            left: { justifyContent: 'left' },
            right: { justifyContent: 'right' },
        },
    },
})

export const StyledInputGroup = styled('div', {
    position: 'relative',

    variants: {
        error: {
            true: {
                [`& ${StyledLabel}, & ${HelperText}`]: {
                    color: '$error600 !important',
                },
            },
        },
        hasLabel: {
            true: {},
            false: {},
        },
        labelPlacement: {
            bottom: { flexDirection: 'column' },
            end: { alignItems: 'center' },
            start: { alignItems: 'center' },
            top: { flexDirection: 'column' },
            inside: { flexDirection: 'column' },
        },
        helperPlacement: {
            left: { justifyContent: 'left' },
            right: { justifyContent: 'right' },
        },
        isChecked: {
            true: {
                gap: '$2',
            },
            false: {
                gap: '$1',
            },
        },
    },

    compoundVariants: [
        {
            hasLabel: true,
            isChecked: false,
            labelPlacement: 'inside',
            css: {
                [`& ${StyledInput}, ${StyledTextarea}`]: {
                    pb: 'calc($2)',
                    pt: 'calc($3 + $1)',

                    '&:not(:focus)::placeholder': {
                        color: 'transparent',
                    },

                    [`&:focus ~ ${StyledLabel}, &:not(:placeholder-shown) ~ ${StyledLabel}`]:
                        {
                            transform:
                                'translate($space$3, $space$1) scale(0.85)',
                        },
                },

                [`& ${StyledLabel}`]: {
                    color: '$neutral400',
                    top: 0,
                    left: 0,
                    pointerEvents: 'none',
                    position: 'absolute',
                    transform:
                        'translate($space$3, calc(($space$3 + $space$2) / 2)) scale(1)',
                    transformOrigin: 'left top',
                    transition: '$default',
                },
            },
        },
        {
            hasLabel: true,
            isChecked: false,
            css: {
                display: 'flex',
            },
        },
        {
            hasLabel: true,
            isChecked: true,
            css: {
                alignItems: 'flex-start',
                display: 'inline-flex',

                [`& ${StyledLabel}`]: {
                    lineHeight: 1.2,
                },
            },
        },
    ],
})
